// Only appRoutes is checked since only appRoutes have permission (not storeRoutes & publicRoutes)
import AppRouteInfo from '../../../../routers/AppRouter/info';
import { matchPath } from 'react-router';

export function getRouteMatch(url) {
    for (const route of AppRouteInfo) {
        const match = matchPath(url, {
            ...route,
            exact: true,
        });
        if (match)
            return match;
    }
    return undefined;
}
